import * as THREE from 'three';

// A single reusable SELECTION outline. Each frame the main loop resolves the interactable the cursor/crosshair is
// aimed at and calls show(obj); the outline wraps that object's bounding box so the player SEES exactly which chest /
// door / station E (or right-click) will operate on -- the same affordance ground drops already have, generalised.
// depthTest off so it reads through walls/props at the edges; hidden when nothing is aimed.
export class SelectionHighlight {
  readonly group = new THREE.Group();
  private readonly box: THREE.LineSegments;
  private readonly bb = new THREE.Box3();
  private readonly c = new THREE.Vector3();
  private readonly s = new THREE.Vector3();

  constructor() {
    const geo = new THREE.EdgesGeometry(new THREE.BoxGeometry(1, 1, 1));
    this.box = new THREE.LineSegments(geo, new THREE.LineBasicMaterial({ color: 0xffe08a, transparent: true, opacity: 0.95, depthTest: false }));
    this.box.renderOrder = 6;
    this.group.add(this.box);
    this.group.visible = false;
  }

  // Wrap `obj`'s world AABB in the outline (a hair larger so it hugs the object), or hide if obj is null/empty.
  show(obj: THREE.Object3D | null): void {
    if (!obj) { this.group.visible = false; return; }
    this.bb.setFromObject(obj);
    if (this.bb.isEmpty()) { this.group.visible = false; return; }
    this.bb.getCenter(this.c); this.bb.getSize(this.s);
    this.box.position.copy(this.c);
    this.box.scale.set(this.s.x + 0.08, this.s.y + 0.08, this.s.z + 0.08);
    this.group.visible = true;
  }

  hide(): void { this.group.visible = false; }
}
